import { useTranslation } from 'react-i18next';

import { VEHICLE_TYPES } from '../constants';

export const useVehicleTypeOptions = () => {
    const { t } = useTranslation('common');

    return VEHICLE_TYPES.map((key) => ({
        value: Number(key),
        label: t(`entities.vehicle.type.${key}`),
    }));
};
